import React, { Component } from "react";
import { SelectedItem } from "./selected-item";
import * as notify from "../../../shared/notify";

const ListOfComplex = (WrappedComponent) => {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                values: this.setDefaultValue(this.props.value || props.defaultValue, []),
                currentValue: this.props.prefill || "",
                isDirty: false,
            };

            this.inputRef = null;
        }

        setDefaultValue = (value, values) => {
            if (!value && values.length === 0) {
                return [];
            }

            if (!Array.isArray(value)) {
                this.reportUp([value]);

                return [value];
            }

            return value;
        };

        componentDidUpdate(prevProps) {
            if (prevProps.value !== this.props.value) {
                this.setState({
                    values: this.setDefaultValue(this.props.value || this.props.defaultValue, this.state.values),
                });
            }
        }

        reportUp = (values) => {
            if (this.props.updateOnChange) {
                this.props.updateOnChange(this.props.name, values);
            }

            // Set Focus
            if (this.inputRef) {
                this.inputRef.current.focus();
            }
        };

        onClickAdd = (e) => {
            if (!this.state.currentValue || !this.state.currentValue.value || !this.state.currentValue.uom) {
                notify.error("Value and UOM are required");

                return;
            }

            const vals = [...this.state.values, this.state.currentValue];
            this.setState({
                values: vals,
                currentValue: this.props.prefill || "",
                isDirty: false,
            });
            this.reportUp(vals);
        };

        onFocus = (e) => {
            this.setState({
                isDirty: false,
            });
        };

        onBlur = (e) => {
            if (!this.state.currentValue) {
                return;
            }

            this.setState({
                isDirty: true,
            });
        };

        removeValue = (index) => {
            const newValues = [...this.state.values];
            newValues.splice(index, 1);

            this.setState({
                values: newValues,
            });

            this.reportUp(newValues);
        };

        aggregateValues = (key, value) => {
            this.setState({
                currentValue: value,
            });
        };

        handleEnter = (e) => {
            if (e.which === 13 || e.keyCode === 13) {
                this.onClickAdd();

                return false;
            }
        };

        render() {
            const totalValues = this.state.values.length;
            const selected =
                this.state.values && this.state.values.length > 0
                    ? this.state.values.map((value, index) => {
                          return <SelectedItem key={`selectedItem_${index}of${totalValues}`} index={index} value={value} text={value} removeValue={this.removeValue} />;
                      })
                    : null;
            const cssClass = this.state.isDirty ? "input-group -dirty" : "input-group";

            return (
                <div>
                    <div>{selected}</div>
                    <div className={cssClass}>
                        <WrappedComponent
                            {...this.props}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            updateOnChange={this.aggregateValues}
                            onChange={(e) => {}}
                            onKeyPress={this.handleEnter}
                            defaultValue={this.state.currentValue}
                        />
                        <button className="button -primary" onClick={this.onClickAdd}>
                            +
                        </button>
                    </div>
                </div>
            );
        }
    };
};

export default ListOfComplex;
